import { render, staticRenderFns } from "./ProductSegmentListing.vue?vue&type=template&id=09a04370&scoped=true"
import script from "./ProductSegmentListing.vue?vue&type=script&lang=ts"
export * from "./ProductSegmentListing.vue?vue&type=script&lang=ts"
import style0 from "./ProductSegmentListing.vue?vue&type=style&index=0&id=09a04370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a04370",
  null
  
)

export default component.exports